import request from '@/utils/request'

let API = '/dev-api'

// 上传图片
export function upload(data) {
    return request({
        url: `/swx/customer/user/upload`,
        method: 'post',
        data
    })
}
